<template>
    <v-dialog
        :value="value"
        persistent
        max-width="640px"
        :retain-focus="false"
        @input="closeDialog"
    >
        <v-card v-if="value">
            <v-card-title class="text-h5 text--primary"
                >Closure notes</v-card-title
            >
            <v-card-text>
                <v-card class="mb-4" outlined elevation="2">
                    <v-card-title class="py-2">
                        <span
                            class="subtitle-1 font-weight-medium text--primary"
                            >Finish notes</span
                        >
                    </v-card-title>
                    <v-card-text>
                        <template v-if="workOrder.finishNotes">
                            <p
                                class="body-1 text--primary mb-3"
                                style="white-space: pre-wrap"
                            >
                                {{ workOrder.finishNotes.notes }}
                            </p>
                            <div class="d-flex justify-end align-center">
                                <span class="caption text--secondary">
                                    {{
                                        formatClosureUser(
                                            workOrder.finishNotes.sentBy
                                        )
                                    }}
                                </span>
                                <v-icon x-small class="mx-1" color="grey"
                                    >mdi-circle-small</v-icon
                                >
                                <span class="caption text--secondary">
                                    {{
                                        formatClosureDate(
                                            workOrder.finishNotes.sentOn
                                        )
                                    }}
                                </span>
                            </div>
                        </template>
                        <p v-else class="text--primary body-1 mb-0">
                            No finish notes recorded.
                        </p>
                    </v-card-text>
                </v-card>
                <v-divider class="my-4" />
                <v-card outlined elevation="2">
                    <v-card-title class="py-2">
                        <span
                            class="subtitle-1 font-weight-medium text--primary"
                            >Closed notes</span
                        >
                    </v-card-title>
                    <v-card-text>
                        <template v-if="workOrder.closedNotes">
                            <p
                                class="body-1 text--primary mb-3"
                                style="white-space: pre-wrap"
                            >
                                {{ workOrder.closedNotes.notes }}
                            </p>
                            <div class="d-flex justify-end align-center">
                                <span class="caption text--secondary">
                                    {{
                                        formatClosureUser(
                                            workOrder.closedNotes.sentBy
                                        )
                                    }}
                                </span>
                                <v-icon x-small class="mx-1" color="grey"
                                    >mdi-circle-small</v-icon
                                >
                                <span class="caption text--secondary">
                                    {{
                                        formatClosureDate(
                                            workOrder.closedNotes.sentOn
                                        )
                                    }}
                                </span>
                            </div>
                        </template>
                        <p v-else class="text--primary body-1 mb-0">
                            No closed notes recorded.
                        </p>
                    </v-card-text>
                </v-card>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn text color="primary" @click="closeDialog" rounded
                    >OK</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment'

export default {
    name: 'WoClosureNotes',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        workOrder: {
            type: Object,
            required: true,
        },
        users: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        closeDialog() {
            this.$emit('close')
        },
        formatClosureUser(userId) {
            if (!userId) {
                return 'Unknown user'
            }
            const user = this.users.find(x => x.id === userId)
            if (user) {
                return user.name || user.email || userId
            }
            return userId
        },
        formatClosureDate(sentOn) {
            if (!sentOn) {
                return '—'
            }
            const seconds = sentOn.seconds ?? sentOn._seconds
            if (seconds != null) {
                return `${moment.unix(seconds).format('L')} ${moment
                    .unix(seconds)
                    .format('LT')}`
            }
            if (typeof sentOn === 'string' || sentOn instanceof Date) {
                return moment(sentOn).format('L LT')
            }
            return '—'
        },
    },
}
</script>
